import { useCallback, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import { createOpenDockCarrier } from '../../use-cases/createOpenDockCarrier'

type CreateOpenDockCarrierParams = {
  shipmentUUID: string
  firstName: string
  lastName: string
}

export function useCreateOpenDockCarrier() {
  const [requestStatus, setRequestStatus] = useState(RequestStatus.Initial)

  const create = useCallback(
    async ({ shipmentUUID, firstName, lastName }: CreateOpenDockCarrierParams) => {
      setRequestStatus(RequestStatus.Pending)
      try {
        const carrier = await createOpenDockCarrier({ shipmentUUID, firstName, lastName })
        setRequestStatus(RequestStatus.Done)
        return carrier
      } catch (error) {
        setRequestStatus(RequestStatus.Error)
        return null
      }
    },
    []
  )

  return { create, requestStatus }
}
